import React from 'react';
import { MDBFooter } from 'mdb-react-ui-kit';
import { ReactLogo } from './ReactLogo';


 function Footer() {
  return (
    
    <div>
<center>
    <footer>
      
      <div>
      Copyright ©   {new Date().getFullYear()} SuaIcontec:  https://www.icontec.org 
      </div>
    </footer>
  
    </center>
<ReactLogo />
    </div>
    
  );
}
export default Footer;